import "@fontsource/lato";
import "@fontsource/roboto";
import "@fontsource/poppins";
import "rsuite/dist/rsuite.min.css";

import { ChakraProvider } from "@chakra-ui/react";
import { theme } from "../src/styles/theme";

import Routes from "./routes";
import { BrowserRouter } from "react-router-dom";
import { SidebarDrawerProvider } from "./context/SidebarDrawerContext";
import AppProvider from "./hooks";
import { AxiosInterceptor } from "./services/interceptor";

function App() {
  return (
    <BrowserRouter>
      <ChakraProvider theme={theme}>
        <SidebarDrawerProvider>
          <AppProvider>
            <AxiosInterceptor>
              <Routes />
            </AxiosInterceptor>
          </AppProvider>
        </SidebarDrawerProvider>
      </ChakraProvider>
    </BrowserRouter>
  );
}

export default App;
